import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { KPICreateParams } from "../Create/KPICreateParams";
import { KPILocalSection } from "../Edit/KPIAdminEditSections/KPILocalSection";

type P =
  | {
      type: "Edit";
      routineId: string;
      title: string;
      localGoalsActive?: boolean;
      localGoalDirection?: "greater" | "less";
      remoteSections: KPILocalSection[];
      localSections: {
        readonly id: string;
        readonly title: string | null;
        readonly goalValue: number;
        readonly assignedTeam: {
          id: string;
        };
      }[];
      removeSections: string[];
    }
  | ({
      type: "Create";
    } & KPICreateParams);

type ParamList = {
  KPICreateSubTeamSelectTeam: P;
  KPICreateSubTeamSetName: {
    name: string;
    teamId: string;
  } & P;
};
export const KPICreateSubTeamStack = createNativeStackNavigator<ParamList>();

export type KPICreateSubTeamScreenProps<K extends keyof ParamList> = {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"KPICreateSubTeam">,
    NativeStackNavigationProp<ParamList, K>
  >;
  route: RouteProp<ParamList, K>;
};
